export default {
    root: {
        padding: '16px 24px'
    },
    action: {
        marginTop: 0,
        marginRight: 0
    }
};
